import { NotificationBrowserEvents, useRefreshQueriesOn } from '@/lib/browser-events'

import { notificationKeys } from '../../api/query-keys'

export function useNotificationHub(): void {
  useRefreshQueriesOn(NotificationBrowserEvents.notificationsChanged, [
    notificationKeys.root,
  ])
}
